import { useSelector } from 'react-redux'
import { useQuery } from '@apollo/react-hooks'
import { GET_SCENARIO_ATTACKS } from '../../queries/scenario'

export default function AttackLayer(props) {
  const { selectedScenarioId, remoteStorage } = useSelector(state => state)

  if (remoteStorage.obstacles) {
    const { loading, error, refetch } = useQuery(GET_SCENARIO_ATTACKS, {
      variables: { id: selectedScenarioId },
      onCompleted: data => {
        console.log('GET_SCENARIO_ATTACKS on completed')
        if (data && data.scenario) {
          data.scenario.attacks.map(attack => {
            const allMapObjectIds = props.draw
              .getAll()
              .features.map(item => item.id)
            if (!allMapObjectIds.includes(attack.geom_guid)) {
              props.draw.add(JSON.parse(attack.geojson))
            }
          })
        }
      },
    })

    if (loading) return null
    if (error) return `Error! ${error}`

    refetch()
  }

  return null
}
